import { ImportedModelItem, InspModelItem, StatusItem } from "@types";
import { Dispatch, SetStateAction } from "react";
import MakeDataSetContent from "./MakeDataSetContent";
import StatusContent from "./StatusContent";
import { SF } from "../../../utils/utils";
import { Box } from "@mui/material";
import { FilterState } from "../../../@types/services/inspStatusService";
import StatusModalHeader from "./StatusModalHeader";

interface StatusModalBodyProps {
  variant: "modal" | "popup";
  onClose: () => void;
  onPopup?: () => void;

  openMakeDataSet: boolean;
  setOpenMakeDataSet: (open: boolean) => void;

  // StatusContent에 필요한 props
  form: StatusItem;
  setForm: Dispatch<SetStateAction<StatusItem>>;
  imageSrc: string | null;
  setImageSrc: (img: string | null) => void;
  onPrevious: () => void;
  onNext: () => void;
  onJump: (id: number, ascIndex: number, total: number) => void;

  // MakeDataSetContent에 필요한 props
  filters: FilterState;
  totalDataCount: number;
  importedModel: ImportedModelItem | null;
  reviewOptions: string[];
}

export default function StatusModalBody({
  variant,
  onClose,
  onPopup,
  openMakeDataSet,
  setOpenMakeDataSet,
  form,
  setForm,
  imageSrc,
  setImageSrc,
  onPrevious,
  onNext,
  onJump,
  filters,
  totalDataCount,
  importedModel,
  reviewOptions,
}: StatusModalBodyProps) {
  return variant === "modal" ? (
    <Box
      sx={{
        width: 1000,
        height: 800,
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        borderRadius: "14px",
        overflow: "hidden",
        outline: "none",
        fontFamily: SF,
      }}
    >
      {variant === "modal" && (
        <StatusModalHeader openMakeDataSet={openMakeDataSet} onClose={onClose} onPopup={onPopup} />
      )}

      {openMakeDataSet ? (
        <MakeDataSetContent
          onClose={onClose}
          onPrevious={() => setOpenMakeDataSet(false)}
          filters={filters}
          totalDataCount={totalDataCount}
        />
      ) : (
        <StatusContent
          form={form}
          setForm={setForm}
          imageSrc={imageSrc}
          setImageSrc={setImageSrc}
          onPrevious={onPrevious}
          onNext={onNext}
          onJump={onJump}
          variant={variant}
          openMakeDataSet={openMakeDataSet}
          setOpenMakeDataSet={setOpenMakeDataSet}
          importedModel={importedModel}
          reviewOptions={reviewOptions}
          onPopup={onPopup}
        />
      )}
    </Box>
  ) : (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        overflow: "hidden",
        outline: "none",
        fontFamily: SF,
      }}
    >
      {openMakeDataSet ? (
        <MakeDataSetContent
          onClose={onClose}
          onPrevious={() => setOpenMakeDataSet(false)}
          filters={filters}
          totalDataCount={totalDataCount}
        />
      ) : (
        <StatusContent
          form={form}
          setForm={setForm}
          imageSrc={imageSrc}
          setImageSrc={setImageSrc}
          onPrevious={onPrevious}
          onNext={onNext}
          onJump={onJump}
          variant={variant}
          openMakeDataSet={openMakeDataSet}
          setOpenMakeDataSet={setOpenMakeDataSet}
          importedModel={importedModel}
          reviewOptions={reviewOptions}
          onPopup={onPopup}
        />
      )}
    </Box>
  );
}
